/**
 * Lazy initializer for marketing pixels (GA4, Meta Pixel, Reddit Pixel).
 * Only invoked on public/marketing routes so the trackers don't load — and
 * trip CSP — on authenticated routes.
 */

const GA_ID = 'G-S836D0MQ34'
const META_PIXEL_ID = '4432238850341890'
const REDDIT_PIXEL_ID = 'a2_i0fqeq7dvwn1'

let initialized = false

const appendScript = (src) => {
  const script = document.createElement('script')
  script.async = true
  script.src = src
  document.head.appendChild(script)
}

const initGoogleAnalytics = () => {
  window.dataLayer = window.dataLayer || []
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', GA_ID)
  appendScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`)
}

const initMetaPixel = () => {
  if (window.fbq) return
  const n = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  appendScript('https://connect.facebook.net/en_US/fbevents.js')
  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

const initRedditPixel = () => {
  if (window.rdt) return
  const p = function () {
    p.sendEvent
      ? p.sendEvent.apply(p, arguments)
      : p.callQueue.push(arguments)
  }
  p.callQueue = []
  window.rdt = p
  appendScript('https://www.redditstatic.com/ads/pixel.js')
  window.rdt('init', REDDIT_PIXEL_ID)
}

export const initPublicPixels = () => {
  if (initialized || typeof window === 'undefined') return
  initialized = true
  initGoogleAnalytics()
  initMetaPixel()
  initRedditPixel()
}
